import BaseModel from "../default/base-model";

export class Category extends BaseModel {
    id?: number;
    name: string;
    description?: string;
    active: boolean;
    url: string;

    constructor() {
        super();
        this.id = undefined;
        this.name = "";
        this.description = "";
        this.active = true;
        this.url = "";
    }
}
